export default "__VITE_ASSET__CDfI_ONv__"